import Providers from './providers';
import AppRouter from './app.router';
import UpgradePromptModal from '../components/UpgradePromptModal';
import CircleAgreementModal from '../components/circles/CircleAgreementModal';
import EmpathyNormsModal from '../components/empathy/EmpathyNormsModal';
import GuestUpgradeModal from '../components/auth/GuestUpgradeModal';
import VersionGate from '../components/VersionGate';
import AccountSuspendedScreen from '../components/AccountSuspendedScreen';
import { stashSignupSourceFromUrl, stashSignupVariantFromUrl } from '../utils/signup-source';

// Attribution stash, once per document load, BEFORE the router can rewrite
// the URL: a comic-referred arrival lands on /learn/{slug}?src=storyforge and
// the param must survive until registration (utils/signup-source.ts). Module
// scope, not an effect — StrictMode double-invokes effects, and the stash is
// first-touch-wins so even that would be harmless, but the raw landing URL is
// only guaranteed to still be in the address bar right now.
// Unconditional — a persisted token proves nothing until /me validates it
// (Codex #823 r5); the setAuthState chokepoint spends the hint the moment
// any authentication actually SUCCEEDS, boot validation included.
stashSignupSourceFromUrl(window.location.search);
stashSignupVariantFromUrl(window.location.search);

function App() {
  // Sign-ins and account switches start their own reads in the auth store's
  // session-change path (stores/auth.store.ts); boot reads come from initAuth.
  return (
    <Providers>
      <VersionGate>
        <AppRouter />
      </VersionGate>
      {/* Global modal — opened by the axios interceptor on 402 / 403
          with our structured error_codes. Single instance for the
          whole app; do not mount UpgradePromptModal anywhere else. */}
      <UpgradePromptModal />
      {/* Global modal — opened by the same interceptor on a 403
          circle_agreement_required, which parks the session-join request until
          the user accepts. Single instance; see stores/circle-agreement.store.ts. */}
      <CircleAgreementModal />
      {/* "How empathy calls work" — the 1:1 first-call norms, opened by the same
          interceptor on a 403 empathy_norms_required. The server asks for the
          agreement first, so this only ever follows it. stores/empathy-norms.store.ts. */}
      <EmpathyNormsModal />
      {/* Global guest-upgrade prompt — opened by gated in-page actions while touring
          as a guest (see guest-upgrade.store). Single instance, like the modals above. */}
      <GuestUpgradeModal />
      {/* Full-screen "Account suspended", raised on any account_banned 403
          (stores/account-ban.store.ts). Last, so it covers everything above. */}
      <AccountSuspendedScreen />
    </Providers>
  );
}

export default App;
